module.exports = __webpack_public_path__ + "img/ic-faq.d5428ae.svg";